import type { AuditLogEvent } from '../../../domain/audit-log-event'

import { AuditLogAction } from '../../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../../domain/audit-log-resource-type.enum'

interface Props {
  auditLog: AuditLogEvent
}

export const CheckRunRerunResourceColumn = (props: Props): JSX.Element | null => {
  if (
    props.auditLog.resource?.type !== AuditLogResourceType.CheckRun ||
    props.auditLog.action !== AuditLogAction.Rerun
  ) {
    return null
  }

  const idsCount = (props.auditLog.resource.data?.ids ?? []).length

  return <span className='font-bold'>{idsCount} Check Runs</span>
}
